import Info from 'components/shared/Info'
import InfoWrapper from 'components/shared/InfoWrapper'
import { FormattedMessage } from 'react-intl'

const SummaryInfo = () => (
    <InfoWrapper padding={[16, 24]}>
        <Info color="info_warning" hasNoBackground={true} hasNoPadding={true}>
            <FormattedMessage
                id="annual.summary.info_double_check"
                defaultMessage="Upewnij się, że wpisane dane są poprawne. Błędy mogą uniemożliwić Ci wejście do parku"
            />
        </Info>
    </InfoWrapper>
)

export default SummaryInfo
